import Service from "@/service/api.js";
import { getSocket } from "@/service/socketio.service";

//  helper function สำหรับแปลง data จาก DB เข้าสู่โครงสร้างที่ UI ต้องการ
const format = (data) => {
  return data.map((b) => ({
    _id: b._id,
    buildingCode: b.BUILDINGCODE,
    rooms: b.rooms
  }));
};

const state = {
  buildings: [],
  initialized: false
};

const getters = {
  buildings: (state) => state.buildings,
  initialized: (state) => state.initialized
};

const mutations = {
  SET_BUILDINGS(state, payload) {
    state.buildings = payload;
  },
  SET_INITIALIZED(state, value) {
    state.initialized = value;
  }
};

const actions = {
  //  โหลดครั้งแรก (ใช้ cache ถ้า initialized เป็น true แล้ว)
  async fetchBuildings({ state, commit }) {
    if (state.initialized) return;

    return Service.building('get', {}, {})
      .then((response) => {
        commit("SET_BUILDINGS", format(response.data));
        commit("SET_INITIALIZED", true);
        return response.data;
      })
      .catch((err) => {
        console.error("Fetch Buildings Error:", err);
        throw err;
      });
  },

  //  ดึงข้อมูลใหม่เสมอ (ใช้หลังจาก Socket แจ้งเตือน)
  async refreshBuildings({ commit }) {
    return Service.building('get', {}, {})
      .then((response) => {
        commit("SET_BUILDINGS", format(response.data));
      })
      .catch((err) => {
        console.error("Refresh Buildings Error:", err);
      });
  },

  //  จัดการ Realtime Connection
  initSocket({ dispatch, rootGetters }) {
    // ตรวจสอบสิทธิ์ว่าเป็น admin หรือไม่
    if (rootGetters["auth/role"] !== "admin") return;

    const socket = getSocket();
    if (!socket) {
      console.warn(" Socket ยังไม่ได้เชื่อมต่อ!");
      return;
    }

    // ล้าง event เก่าก่อนป้องกันการรับข้อมูลซ้ำ (Duplicate Listeners)
    socket.off("building-updated");

    socket.on("building-updated", () => {
      console.log(" Socket received: building-updated");
      dispatch("refreshBuildings");
    });
  },

  //  เพิ่มอาคาร / ห้อง
  async addBuilding({ commit }, data) {
    // หมายเหตุ: ใช้ Service.building (ไม่มี s) ตามที่คุณระบุในตัวอย่าง
    return Service.building('post', data, {})
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.error("Add Building Error:", err);
        throw err; // throw เพื่อให้ Swal ใน Component ดักจับ error ได้
      });
  },

  //  แก้ไขห้อง (ส่ง roomId และ newRoomName)
  async editRoom({ commit }, { roomId, newRoomName }) {
    return Service.building('put', { roomId, newRoomName }, {})
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.error("Edit Room Error:", err);
        throw err;
      });
  },

  // ลบอาคาร (ทั้งอาคาร)
  async deleteBuilding({ commit }, buildingId) {
    return Service.building('delete', {}, { urlAppend: `/${buildingId}` })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.error("Delete Building Error:", err);
        throw err;
      });
  },

  // ลบห้อง (roomId)
  async deleteRoom({ commit }, roomId) {
    return Service.building('delete', {}, { urlAppend: `/room/${roomId}` })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.error("Delete Room Error:", err);
        throw err;
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};